import { render, staticRenderFns } from "./acts-groups.vue?vue&type=template&id=58f75b90"
import script from "./acts-groups.vue?vue&type=script&lang=js"
export * from "./acts-groups.vue?vue&type=script&lang=js"
import style0 from "./acts-groups.vue?vue&type=style&index=0&id=58f75b90&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports